import React
  from "react";

export const SuccessAlert = (props) => {
  return (
    <div className="wal-alert wal-alert-success">
      <div className="wal-alert-wrap">
        <div className="wal-alert-left">
          <div className="wal-alert-icon">
            <i className="icon-done-check"></i>
          </div>
          <div className="wal-alert-message">
            <p>{props.translate("shared.success_label")}</p>
            <span>{props.message}</span>
          </div>
        </div>
        <div className="wal-alert-right">
          <div className="wal-alert-close">
            {/*<i className="icon-half-x"></i>*/}
          </div>
        </div>
      </div>
    </div>
  )
};

export default SuccessAlert;
